import React, { useState } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AlertComponent from '../../../../components/Alert';
import { getErrorMessage } from '../../../../utils/helper';
import { ticketToolbar } from '../../helpers';
import { addTicketUrl } from '../../../../services/endpoints/tickets';
import TipTap from '../../../../components/TipTap';

const AddTicketModal = ({ onHide, onSubmit }) => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [form, setForm] = useState({
    username: '',
    subject: '',
    message: '',
  });

  const { username, subject, message } = form;

  const onUpdateForm = (key, value) => {
    setForm((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  const onSubmitForm = async () => {
    setLoading(true);
    try {
      await addTicketUrl(form);
      onSubmit()
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Add ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && <div className="modal-loader-small" />}
        {error && <AlertComponent text={error} type="danger" />}
        <div className="ticket-editor">
          <FormGroup>
            <ControlLabel htmlFor="username">Username</ControlLabel>
            <FormControl
              type="text"
              id="username"
              value={username}
              name="username"
              onChange={(e) => onUpdateForm('username', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel htmlFor="subject">Subject</ControlLabel>
            <FormControl
              type="text"
              id="subject"
              value={subject}
              name="subject"
              onChange={(e) => onUpdateForm('subject', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Message</ControlLabel>
            <TipTap
              toolbar={ticketToolbar}
              content={message}
              onChange={(content) => onUpdateForm('message', content)}
            />
          </FormGroup>
        </div>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button
          disabled={isLoading}
          bsStyle="primary"
          type="submit"
          onClick={onSubmitForm}
        >
          <span>Add ticket</span>
        </Button>
        <Button
          disabled={isLoading}
          onClick={onHide}
        >
          Close
        </Button>
      </Modal.Footer>
    </>
  );
};

AddTicketModal.propTypes = {
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddTicketModal;
